import { Box, Card, CardBody, Heading, Link, Stack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { urls } from "../../urls";
import { ChangeCorporateTitle } from "../personal-profile/edit/ChangeCorporateTitle";
import { ChangeEmail } from "../personal-profile/edit/ChangeEmail";
import { ChangeFirstName } from "../personal-profile/edit/ChangeFirstName";
import { ChangeLastName } from "../personal-profile/edit/ChangeLastName";
import { ChangePhoneNumber } from "../personal-profile/edit/ChangePhoneNumber";
import { useCreateMeEditor } from "../personal-profile/edit/useMeEditor";

export const EditProfilePage = () => {
  const { t } = useTranslation();
  useCreateMeEditor();

  return (
    <Box maxW="container.md" mx="auto">
      <Link as={RouterLink} to={urls.app.profile} color="smPrimary" fontSize="sm" fontWeight="semibold">
        ← {t("Back to profile")}
      </Link>
      <Heading as="h1" size="lg" color="smText" mt="2" mb="6">
        {t("Edit personal profile")}
      </Heading>

      <Card variant="outline" rounded="xl" bg="smBackground" borderColor="smBorder" boxShadow="sm">
        <CardBody>
          <Stack spacing="4">
            <ChangeFirstName />
            <ChangeLastName />
            <ChangeEmail />
            <ChangeCorporateTitle />
            <ChangePhoneNumber />
          </Stack>
        </CardBody>
      </Card>
    </Box>
  );
};
